<template>
	<div>
		<div v-if="!buscandoSemanas">
			<label>* {{ _traducao('global', 'malha') }} {{ _traducao('global', 'semana') }}:</label>
			<select v-model="form.malha_semana" class="form-control">
				<option :value="null">{{ _traducao('global', 'escolha') }}</option>
				<option v-for="item in semanas" :value="item.id" :key="item.id">{{ item.descricao }}</option>
			</select>
		</div>
		<div v-if="buscandoSemanas" class="col-weekday__container col-weekday__container--loader u__flex--justify-center text-center">
			<i class="fa fa-refresh fa-spin icone-buscando" aria-hidden="true"></i>
		</div>
	</div>
</template>

<script>
export default {
	props: ['form', 'semanas', 'buscandoSemanas']
}
</script>
